module.exports = __webpack_public_path__ + "static/img/R.32b0398.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/R.png
// module id = Bg4o
// module chunks = 0